import EventHubMixin from '@/mixins/EventHub.js'
import APIMixin from '@/mixins/API.js'
import ScrollMixin from '@/mixins/Scroll.js'

import AppPicture from '@/components/app-picture'
import AppContent from '@/components/app-content'
import AppVisualListWidget from '@/components/app-visual-list-widget'

export default
{
    name: 'app-page-simple',

    mixins:
    [
        EventHubMixin,
        APIMixin,
        ScrollMixin
    ],

    components:
    {
        AppPicture,
        AppContent,
        AppVisualListWidget
    },

    data()
    {
        return {
            content: null
        }
    },

    created()
    {
        this.fetch('pages', { slug: this.$route.meta.pageSlug, per_page: 1000 }, (data, error) =>
        {
            // Error
            if(error === true || data.length < 1)
            {
                this.$router.push({ name: '404' })
                return
            }

            this.content = data[0]

            // SEO
            document.title = this.content.acf.seo_title ? this.content.acf.seo_title : this.content.acf.title.replace(/<br ?\/?>/gi, '')
            if(this.content.acf.seo_description)
            {
                document.querySelector('meta[name=description]').content = this.content.acf.seo_description
            }

            // Papillon
            this.$nextTick(() =>
            {
                window.dispatchEvent(new Event('papillon'))
            })
        }, this.$root.isFirstPage())
    },

    mounted()
    {
        this.$eventHub.$emit('headerLogo.setState', { state: 'logo' })
    },

    methods:
    {
        onBackTopClick()
        {
            this.animateTo(0, 1)
        }
    }
}



// WEBPACK FOOTER //
// ./src/components/app-page-simple/script.js